// assets/zk-variant-picker.js
class ZKVariantPicker extends HTMLElement {
  connectedCallback() {
    this.sectionId  = this.dataset.sectionId;
    this.productUrl = this.dataset.url || window.location.pathname;
    this.product    = this.readProductJSON();
    this.form       = this.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');

    this.onChange   = this.onChange.bind(this);
    this.onClickLink= this.onClickLink.bind(this);

    this.addEventListener('change', this.onChange);
    this.addEventListener('input',  this.onChange);
    this.addEventListener('click',  this.onClickLink);

    // Estado inicial
    const currentId = this.currentVariantId();
    if (currentId) {
      this.currentVariant = this.findVariantById(currentId);
      this.updateURL(this.currentVariant?.id);
      this.updateFormId(this.currentVariant?.id);
      this.updateUI(this.currentVariant);
    }
  }

  readProductJSON() {
    try {
      const el = document.querySelector('#zk-product-json,[data-product-json]');
      return el ? JSON.parse(el.textContent) : null;
    } catch(e){ return null; }
  }

  currentVariantId() {
    const i = (this.form && (this.form.querySelector('input[name="id"]') || this.form.querySelector('select[name="id"]'))) || document.querySelector('input[name="id"], select[name="id"]');
    return i && i.value ? String(i.value) : null;
  }

  selectedOptions() {
    if (!this.product) return [];
    const vals = new Array(this.product.options.length).fill('');
    // radios
    this.querySelectorAll('input[type="radio"][name^="options["]:checked').forEach(r=>{
      const name = r.name; // options[Color], options[Talla]...
      const idx = this.indexFromOptionName(name);
      if (idx > -1) vals[idx] = r.value;
    });
    // selects
    this.querySelectorAll('select[name^="options["]').forEach(s=>{
      const idx = this.indexFromOptionName(s.name);
      if (idx > -1) vals[idx] = s.value;
    });
    // fallback: si quedan vacíos intenta leer del DOM global (por si los inputs están fuera)
    if (vals.some(v=>!v)) {
      document.querySelectorAll('input[type="radio"][name^="options["]:checked, select[name^="options["]').forEach(el=>{
        const idx = this.indexFromOptionName(el.name);
        if (idx > -1 && !vals[idx]) vals[idx] = el.value;
      });
    }
    return vals;
  }

  indexFromOptionName(name) {
    // name = "options[Color]" -> buscar índice por etiqueta
    const m = String(name||'').match(/\[(.+)\]/);
    if (!m || !this.product) return -1;
    const label = (m[1]||'').toLowerCase();
    return this.product.options.findIndex(o => String(o).toLowerCase() === label);
  }

  findVariantByOptions(optionValues) {
    if (!this.product) return null;
    return this.product.variants.find(v => (v.options||[]).every((val,i)=> String(val) === String(optionValues[i]))) || null;
  }
  findVariantById(id) {
    return this.product?.variants?.find(v => String(v.id) === String(id)) || null;
  }

  onChange(evt) {
    // Cada vez que cambian radios/selects
    const opts = this.selectedOptions();
    const v    = this.findVariantByOptions(opts);
    if (!v) return;
    this.currentVariant = v;
    this.updateFormId(v.id);
    this.updateURL(v.id);
    this.updateUI(v);
    this.dispatchVariantEvents(v);
  }

  onClickLink(e){
    // Intercepta swatches que usan <a href="?variant=...">
    const a = e.target.closest('a[href*="variant="]');
    if (!a) return;
    e.preventDefault();
    try{
      const id = new URL(a.href).searchParams.get('variant');
      const v  = this.findVariantById(id);
      if (!v) return;
      this.currentVariant = v;
      // Marcar inputs visualmente para que no "salten" estilos
      this.markInputsForVariant(v);
      this.updateFormId(v.id);
      this.updateURL(v.id);
      this.updateUI(v);
      this.dispatchVariantEvents(v);
    }catch(_){}
  }

  markInputsForVariant(v){
    // Radios
    this.querySelectorAll('input[type="radio"][name^="options["]').forEach(r=>{
      const idx = this.indexFromOptionName(r.name);
      if (idx > -1) r.checked = (String(v.options[idx]) === String(r.value));
    });
    // Selects
    this.querySelectorAll('select[name^="options["]').forEach(s=>{
      const idx = this.indexFromOptionName(s.name);
      if (idx > -1) s.value = v.options[idx];
    });
  }

  updateFormId(variantId){
    if (!this.form) return;
    const node = this.form.querySelector('input[name="id"], select[name="id"]');
    if (!node) return;
    node.value = String(variantId);
    node.dispatchEvent(new Event('input',  { bubbles:true }));
    node.dispatchEvent(new Event('change', { bubbles:true }));
  }

  updateURL(variantId){
    if (!variantId) return;
    const url = new URL(this.productUrl, window.location.origin);
    url.searchParams.set('variant', variantId);
    history.replaceState({}, '', url.pathname + url.search);
  }

  async updateUI(variant){
    // 1) Precio/compare price (si tienes nodos marcados)
    const price   = document.querySelector('[data-product-price]');
    const compare = document.querySelector('[data-compare-price]');
    if (price)   price.textContent   = this.formatMoney(variant.price);
    if (compare) compare.textContent = variant.compare_at_price ? this.formatMoney(variant.compare_at_price) : '';

    // 2) Botón ATC habilitado/agotado
    const atc = this.form?.querySelector('[type="submit"], button[name="add"], .product-form__submit');
    if (atc){
      atc.disabled = !variant.available;
      atc.setAttribute('aria-disabled', !variant.available ? 'true' : 'false');
      const txt = atc.querySelector('.atc-text') || atc;
      if (txt) txt.textContent = variant.available ? (txt.dataset?.addText || 'Agregar al carrito') : (txt.dataset?.soldOutText || 'Agotado');
    }

    // 3) Imagen principal (si tu HTML marca data-media-id)
    const media = document.querySelector(`[data-media-id="${variant.featured_media?.id}"]`);
    if (media){
      // Desactiva activos
      document.querySelectorAll('[data-media-id].is-active').forEach(el=> el.classList.remove('is-active'));
      media.classList.add('is-active');
      // Si tienes un <img> principal:
      const main = document.querySelector('[data-product-main-image]');
      if (main) {
        const src = variant.featured_media?.src || variant.featured_image?.src;
        if (src) main.src = src;
      }
    }
  }

  formatMoney(cents){
    if (window.Shopify?.formatMoney) return Shopify.formatMoney(cents, "{{ shop.money_format | replace: '\"', '\\\"' }}");
    return (cents/100).toLocaleString('es-CO', {style:'currency', currency:'COP', minimumFractionDigits:0});
  }

  dispatchVariantEvents(variant){
    document.dispatchEvent(new CustomEvent('variant:change',        { detail:{ variant }}));
    document.dispatchEvent(new CustomEvent('product:variant-change',{ detail:{ variant }}));
  }
}

customElements.define('zk-variant-picker', ZKVariantPicker);
